(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44],{

/***/ 1381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ACDB2BSimulationCalculator; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-button/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(4936);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-icons/dist/index.esm.js + 540 modules
var dist_index_esm = __webpack_require__(6045);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-input/dist/index.esm.js + 3 modules
var sirius_input_dist_index_esm = __webpack_require__(5256);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-popup/dist/popup/index.js
var popup = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(8642);
// EXTERNAL MODULE: ./src/components/shared/Text/index.tsx
var Text = __webpack_require__(1823);
// EXTERNAL MODULE: ./src/utils/formatCurrency/index.ts
var formatCurrency = __webpack_require__(9629);
// EXTERNAL MODULE: ./src/utils/number/addThousandSeparator/index.ts
var addThousandSeparator = __webpack_require__(1268);
// EXTERNAL MODULE: ./src/utils/regex/inputRegex/index.ts
var inputRegex = __webpack_require__(481);
;// CONCATENATED MODULE: ./src/components/pages/ACDB2BPage/components/ACDB2BSimulation/components/ACDB2BSimulationCalculator/config.ts
var repaymentMethodList;
(function(repaymentMethodList) {
    repaymentMethodList["oneTime"] = "repayment_method.one_time";
    repaymentMethodList["installment"] = "repayment_method.installment";
})(repaymentMethodList || (repaymentMethodList = {}));
var repaymentOptions = [
    {
        label: "Satu Kali Pembayaran",
        value: repaymentMethodList.oneTime
    },
    {
        label: "Cicilan",
        value: repaymentMethodList.installment
    }
];
var ACDServiceFee;
(function(ACDServiceFee) {
    ACDServiceFee[ACDServiceFee["b2b"] = 1.59] = "b2b";
    ACDServiceFee[ACDServiceFee["individual"] = 2.5] = "individual";
})(ACDServiceFee || (ACDServiceFee = {}));
var loanInstallmentTerms = [
    2,
    3,
    4,
    5,
    6
];
var agentCommissionDenominator = 1.1;
var ACDCommissionPercentage = 30 / 100;
var oneHundredThousand = 100000;
var defaultFieldState = {
    error: undefined,
    text: "",
    value: 0
};
var unitQuantityDefaultValue = 1;
var repaymentMethodDefaultValue = repaymentMethodList.oneTime;
var loanInstallmentTermsDefaultValue = 6;
var commissionPercentageDefaultValue = 2;

// EXTERNAL MODULE: ./src/components/pages/ACDB2BPage/components/ACDB2BSimulation/components/ACDB2BSimulationCalculator/styles.module.css
var styles_module = __webpack_require__(7866);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/pages/ACDB2BPage/components/ACDB2BSimulation/components/ACDB2BSimulationCalculator/index.tsx















// eslint-disable-next-line max-lines-per-function
var ACDB2BCalculator = function(param) {
    var handleOnApply = param.handleOnApply, _isMobileSticky = param.isMobileSticky, isMobileSticky = _isMobileSticky === void 0 ? false : _isMobileSticky;
    var ref, ref1;
    var ref2 = (0,react.useState)(defaultFieldState), propertyPrice = ref2[0], setPropertyPrice = ref2[1];
    var ref3 = (0,react.useState)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultFieldState), {
        value: commissionPercentageDefaultValue
    })), commissionPercentage = ref3[0], setCommissionPercentage = ref3[1];
    var ref4 = (0,react.useState)(loanInstallmentTermsDefaultValue), tenure = ref4[0], setTenure = ref4[1];
    var ref5 = (0,react.useState)(false), isShowIMark = ref5[0], setIsShowIMark = ref5[1];
    var handlePropertyPriceChanged = (0,react.useCallback)(function(event) {
        var parsedValueNonSeparator = event.target.value.replace(/\./g, "");
        var parsedThousandSeparator = parseInt(parsedValueNonSeparator) ? (0,addThousandSeparator/* default */.Z)(parseInt(parsedValueNonSeparator)) : "";
        if (!inputRegex/* numberRegex.test */.pA.test(parsedValueNonSeparator)) {
            setPropertyPrice((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, propertyPrice), {
                error: Error("Harga properti harus berupa angka"),
                text: parsedThousandSeparator
            }));
            return;
        }
        setPropertyPrice((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, propertyPrice), {
            text: parsedThousandSeparator,
            error: undefined,
            value: parseInt(parsedValueNonSeparator)
        }));
    }, [
        propertyPrice
    ]);
    var handleCommissionPercentageChanged = (0,react.useCallback)(function(event) {
        var value = event.target.value;
        if (!inputRegex/* decimalNumberWithCommaRegex.test */.tj.test(value)) {
            setCommissionPercentage((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commissionPercentage), {
                error: Error("Persentase komisi tidak valid")
            }));
            return;
        }
        var parsedValue = value.replace(",", ".");
        setCommissionPercentage((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commissionPercentage), {
            error: undefined,
            value: parseFloat(parsedValue)
        }));
    }, [
        commissionPercentage
    ]);
    var handleTenureChanged = (0,react.useCallback)(function(event) {
        var value = event.target.value;
        setTenure(parseInt(value));
    }, []);
    var calculatedAgentCommission = (0,react.useMemo)(function() {
        if (!propertyPrice && !commissionPercentage) {
            return 0;
        }
        return Math.round(propertyPrice.value * (commissionPercentage.value / 100) * unitQuantityDefaultValue / agentCommissionDenominator);
    }, [
        commissionPercentage,
        propertyPrice
    ]);
    var calculatedCommissionFromPinhome = (0,react.useMemo)(function() {
        if (!calculatedAgentCommission) {
            return 0;
        }
        return Math.floor(calculatedAgentCommission * ACDCommissionPercentage / oneHundredThousand) * oneHundredThousand;
    }, [
        calculatedAgentCommission
    ]);
    var calculatedAdminFee = (0,react.useMemo)(function() {
        if (!calculatedCommissionFromPinhome) {
            return 0;
        }
        return 2 / 100 * calculatedCommissionFromPinhome;
    }, [
        calculatedCommissionFromPinhome
    ]);
    var calculatedServiceFee = (0,react.useMemo)(function() {
        if (!calculatedCommissionFromPinhome || !tenure) {
            return 0;
        }
        return calculatedCommissionFromPinhome * (ACDServiceFee.b2b / 100) * tenure;
    }, [
        calculatedCommissionFromPinhome,
        tenure
    ]);
    var calculatedTotalServiceFee = (0,react.useMemo)(function() {
        if (!calculatedServiceFee || !calculatedCommissionFromPinhome) {
            return 0;
        }
        return calculatedCommissionFromPinhome;
    }, [
        calculatedCommissionFromPinhome,
        calculatedServiceFee
    ]);
    var calculatedDisbursedCommission = (0,react.useMemo)(function() {
        if (!calculatedAdminFee || !calculatedCommissionFromPinhome) {
            return 0;
        }
        return calculatedCommissionFromPinhome - calculatedAdminFee - calculatedServiceFee;
    }, [
        calculatedAdminFee,
        calculatedCommissionFromPinhome,
        calculatedServiceFee
    ]);
    var isFormValid = (0,react.useMemo)(function() {
        if (!propertyPrice.value || !commissionPercentage.value || !tenure) {
            return false;
        }
        if (propertyPrice.error || commissionPercentage.error) {
            return false;
        }
        return true;
    }, [
        commissionPercentage,
        propertyPrice,
        tenure
    ]);
    var estimationRepaymentText = (0,react.useMemo)(function() {
        var formattedCalculatedTotalServiceFee = (0,formatCurrency/* default */.Z)(parseInt(calculatedTotalServiceFee.toFixed(0)));
        return "".concat(formattedCalculatedTotalServiceFee);
    }, [
        calculatedTotalServiceFee
    ]);
    var toggleIMark = (0,react.useCallback)(function() {
        setIsShowIMark(!isShowIMark);
    }, [
        isShowIMark
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["acd-b2b__simulation-calculator"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default())["acd-b2b__simulation-form"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default())["acd-b2b__simulation-form-input_full"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: (styles_module_default())["form__item-label"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            typography: "label2",
                                            component: "p",
                                            margin: "0 5px 0 0",
                                            children: "Total Harga Jual Properti"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Info16Icon */.T3k, {
                                            onClick: toggleIMark,
                                            "data-testid": "btn-simulation-imark-button"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sirius_input_dist_index_esm/* TextField */.nv, {
                                    prefix: "Rp",
                                    placeholder: "1.000.000.000",
                                    description: ((ref = propertyPrice.error) === null || ref === void 0 ? void 0 : ref.message) || "Masukkan total harga jual (setelah PPN) dari satu atau beberapa properti yang ingin diajukan",
                                    value: propertyPrice.text,
                                    onChange: handlePropertyPriceChanged,
                                    hasError: !!propertyPrice.error,
                                    "data-testid": "txt-acdB2b-propertyPriceInput"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default())["acd-b2b__simulation-form-input"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    typography: "label2",
                                    children: "Tenor Pengembalian"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                    className: (styles_module_default())["acd-b2b__simulation-form-select"],
                                    required: true,
                                    onChange: handleTenureChanged,
                                    "data-testid": "ddl-acdB2b-tenureInput",
                                    defaultValue: loanInstallmentTermsDefaultValue,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "",
                                            disabled: true,
                                            children: "Pilih jangka waktu"
                                        }),
                                        loanInstallmentTerms.map(function(term, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: term,
                                                children: "".concat(term, " bulan")
                                            }, "".concat(term, "-").concat(idx));
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default())["acd-b2b__simulation-form-input"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    typography: "label2",
                                    children: "Rata-rata Komisi Agen"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sirius_input_dist_index_esm/* TextField */.nv, {
                                    suffix: "%",
                                    placeholder: "0",
                                    description: ((ref1 = commissionPercentage.error) === null || ref1 === void 0 ? void 0 : ref1.message) || "Rata-rata komisi untuk agen",
                                    onChange: handleCommissionPercentageChanged,
                                    hasError: !!commissionPercentage.error,
                                    "data-testid": "txt-acdB2b-commissionPercentageInput",
                                    defaultValue: commissionPercentageDefaultValue
                                })
                            ]
                        })
                    ]
                })
            }),
            isFormValid && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)((styles_module_default())["acd-b2b__simulation-estimation"], (styles_module_default())["acd-b2b__simulation-estimation_green"]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["acd-b2b__simulation-estimation-text"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    typography: "label1",
                                    children: "Total Komisi Instan yang Dapat Dicairkan"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["acd-b2b__simulation-estimation-text"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    typography: "heading2",
                                    color: "positive",
                                    children: (0,formatCurrency/* default */.Z)(parseInt(calculatedDisbursedCommission.toFixed(0)))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["acd-b2b__simulation-estimation-text"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    typography: "body3",
                                    children: [
                                        "Sudah dipotong biaya admin & layanan sebesar ",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            typography: "label3",
                                            children: [
                                                " ",
                                                (0,formatCurrency/* default */.Z)(parseInt((calculatedServiceFee + calculatedAdminFee).toFixed(0)))
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)((styles_module_default())["acd-b2b__simulation-estimation"], (styles_module_default())["acd-b2b__simulation-estimation_subtle"]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["acd-b2b__simulation-estimation-text"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    typography: "label1",
                                    margin: "0 0 4px",
                                    children: "Total Tagihan yang Harus Dibayar"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["acd-b2b__simulation-estimation-text"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    typography: "heading2",
                                    color: "attentive",
                                    children: estimationRepaymentText
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["acd-b2b__simulation-estimation-text"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    typography: "body3",
                                    margin: "0 0 4px",
                                    children: "Dibayar pada saat jatuh tempo"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((styles_module_default())["acd-b2b__simulation-estimation-cta"], isMobileSticky && (styles_module_default())["acd-b2b__simulation-estimation-cta_sticky"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ButtonPrimary */.DF, {
                    fullWidth: true,
                    onClick: handleOnApply,
                    target: "_blank",
                    disabled: !isFormValid,
                    testId: "btn-acdb2b-landing-page-simulation-apply",
                    children: "Ajukan Sekarang"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* default */.ZP, {
                isOpen: isShowIMark,
                testId: "simulation-popup-imark",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default())["acd-b2b__simulation-estimation__imark"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default())["acd-b2b__simulation-estimation__imark-title"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                typography: "heading3",
                                children: "Contoh Total Harga Jual Properti"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default())["acd-b2b__simulation-estimation__imark-content"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                typography: "body1",
                                children: "Pengajuan Komisi Instan untuk 2 properti dengan harga jual Rp600 juta dan Rp400 juta (setelah PPN)."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default())["acd-b2b__simulation-estimation__imark-content"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                typography: "body1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        typography: "label1",
                                        children: "Total Harga Jual Properti = Rp 1 miliar"
                                    }),
                                    " ",
                                    " ",
                                    "(Rp600 juta + Rp400 juta)"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default())["acd-b2b__simulation-estimation__imark-cta"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ButtonPrimary */.DF, {
                                testId: "btn-simulationPopup-close-button",
                                onClick: toggleIMark,
                                children: "Tutup"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ACDB2BSimulationCalculator = (ACDB2BCalculator);


/***/ }),

/***/ 3180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_SubmissionPopUp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-button/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(4936);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-checkbox/dist/checkbox/index.js
var dist_checkbox = __webpack_require__(6954);
var checkbox_default = /*#__PURE__*/__webpack_require__.n(dist_checkbox);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-icons/dist/index.esm.js + 540 modules
var dist_index_esm = __webpack_require__(6045);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-popup/dist/popup/index.js
var popup = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/@pinvest/sirius-snackbar/dist/snackbar/index.js
var snackbar = __webpack_require__(4515);
var snackbar_default = /*#__PURE__*/__webpack_require__.n(snackbar);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/shared/Spinner/index.tsx
var Spinner = __webpack_require__(7403);
// EXTERNAL MODULE: ./src/components/shared/Text/index.tsx
var Text = __webpack_require__(1823);
// EXTERNAL MODULE: ./src/constants/loan.ts
var loan = __webpack_require__(8817);
// EXTERNAL MODULE: ./src/repositories/loan/submit-loan/useSubmitLoan.ts + 1 modules
var useSubmitLoan = __webpack_require__(8653);
;// CONCATENATED MODULE: ./src/components/shared/SubmissionPopUp/config.ts
var SubmissionPopUpIllustration = "https://pinhome-web-assets.imgix.net/pinfinance/submission-illustration-2.png";

// EXTERNAL MODULE: ./src/components/shared/SubmissionPopUp/styles.module.css
var styles_module = __webpack_require__(2615);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/SubmissionPopUp/index.tsx
















var SubmissionPopUp = function(param) {
    var _isShowSubmissionPopUp = param.isShowSubmissionPopUp, isShowSubmissionPopUp = _isShowSubmissionPopUp === void 0 ? false : _isShowSubmissionPopUp, closeModal = param.closeModal, userEmail = param.userEmail, succeedCallback = param.succeedCallback;
    var ref = (0,react.useState)(false), agreeField = ref[0], setAgreeField = ref[1];
    var handleSubmitLoanSuccess = (0,react.useCallback)(function() {
        closeModal();
        snackbar_default().show({
            variant: "positive",
            content: "Berhasil mengirim template pengajuan.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Success16Icon */.QZr, {
                color: "white"
            })
        });
        if (succeedCallback) {
            succeedCallback();
        }
    }, [
        closeModal,
        succeedCallback
    ]);
    var handleSubmitLoanFailed = (0,react.useCallback)(function() {
        snackbar_default().show({
            variant: "negative",
            content: "Terjadi kesalahan pada server, mohon coba kembali nanti"
        });
    }, []);
    var ref1 = (0,useSubmitLoan/* default */.Z)({
        onSuccess: handleSubmitLoanSuccess,
        onError: handleSubmitLoanFailed
    }), isLoading = ref1.isLoading, submitLoan = ref1.fetch;
    var handleOnSentClicked = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return submitLoan({
                        productTypeLocaleKey: loan/* LOAN_PRODUCT_TYPE.ACD_B2B */.nF.ACD_B2B
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        submitLoan
    ]);
    var handleAgreementCheck = (0,react.useCallback)(function(event) {
        var value = event.target.checked;
        setAgreeField(value);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* default */.ZP, {
        testId: "popup-submission",
        isOpen: isShowSubmissionPopUp,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).submission__popup,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default())["submission__popup-header"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default())["submission__popup-header-image"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "dashboard-popup-success-illustration",
                                src: SubmissionPopUpIllustration,
                                layout: "responsive",
                                objectFit: "contain",
                                width: 128,
                                height: 65
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default())["submission__popup-header-button"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconButton */.hU, {
                                onClick: closeModal,
                                disabled: isLoading,
                                testId: "btn-submission-modalClose",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Close16Icon */.Poq, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default())["submission__popup-body"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            typography: "heading2",
                            component: "p",
                            margin: "0 0 12px",
                            children: "Template Pengajuan Akan Dikirim ke Email Anda"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            typography: "body2",
                            component: "p",
                            margin: "0 0 12px",
                            children: [
                                "Silakan isi template pengajuan Komisi Instan yang akan kami kirimkan ke email Anda di ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: userEmail
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default())["submission__popup-checkbox__wrapper"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default())["submission__popup-checkbox"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((checkbox_default()), {
                                        name: "",
                                        checked: agreeField,
                                        testId: "chk-createLoanRequest-modal",
                                        onChange: handleAgreementCheck
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    typography: "body2",
                                    color: "subtle",
                                    children: "Dengan ini saya menyetujui data profil saya digunakan untuk pengecekan Pefindo"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default())["submission__popup-ctas"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default())["submission__popup-cta"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ButtonOutline */.Ig, {
                                testId: "btn-submission-modalCancel",
                                onClick: closeModal,
                                fullWidth: true,
                                disabled: isLoading,
                                children: "Batal"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default())["submission__popup-cta"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ButtonPrimary */.DF, {
                                testId: "btn-submission-modalApply",
                                onClick: handleOnSentClicked,
                                fullWidth: true,
                                disabled: isLoading || !agreeField,
                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                    color: "white",
                                    size: "standard",
                                    "data-testid": "spinner-submission-modalApply"
                                }) : "Kirim Template Pengajuan"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shared_SubmissionPopUp = (SubmissionPopUp);


/***/ }),

/***/ 8514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ icpPartnerDisclaimer; }
/* harmony export */ });
var icpPartnerDisclaimer = "Layanan Komisi Instan Pinhome didukung oleh PT Indo Fin Tek yang terdaftar dan diawasi oleh OJK.";


/***/ }),

/***/ 8653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ submit_loan_useSubmitLoan; }
});

// EXTERNAL MODULE: ./src/repositories/useMutation.ts
var useMutation = __webpack_require__(8858);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/repositories/fetcher.ts
var fetcher = __webpack_require__(5140);
// EXTERNAL MODULE: ./src/repositories/utils.ts + 10 modules
var utils = __webpack_require__(7115);
// EXTERNAL MODULE: ./src/services/cookies/oauth/index.ts + 1 modules
var oauth = __webpack_require__(3731);
;// CONCATENATED MODULE: ./src/repositories/loan/submit-loan/index.ts







var submitLoan = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
        var ref, ref1, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    ;
                    _ctx.next = 4;
                    return (0,fetcher/* default */.Z)({
                        method: "POST",
                        url: "/api/loan/submit-loan",
                        body: body,
                        headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getHeadersWithBasicAuth */.Iy)()), {
                            Accept: "application/json",
                            "x-auth": (ref1 = (ref = (0,oauth/* getAccessToken */.hP)()) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : ""
                        })
                    });
                case 4:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function submitLoan(body) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var submit_loan = (submitLoan);

;// CONCATENATED MODULE: ./src/repositories/loan/submit-loan/useSubmitLoan.ts


var useSubmitLoan = function(options) {
    var resp = (0,useMutation/* default */.Z)(submit_loan, options);
    return resp;
};
/* harmony default export */ var submit_loan_useSubmitLoan = (useSubmitLoan);


/***/ }),

/***/ 8858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7115);




// POST | PUT | PATCH with body request is required OR GET with required slug 
// used to create/update/delete/get
var useMutation = function(fetcher, options) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(_utils__WEBPACK_IMPORTED_MODULE_2__/* .fetchReducer */ .QX, _utils__WEBPACK_IMPORTED_MODULE_2__/* .reducerInitialState */ .SO), state = ref[0], dispatch = ref[1];
    var handleSuccess = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(data) {
        if (typeof (options === null || options === void 0 ? void 0 : options.onSuccess) === "function") {
            options.onSuccess(data);
        }
    }, [
        options
    ]);
    var handleError = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(err) {
        if (typeof (options === null || options === void 0 ? void 0 : options.onError) === "function") {
            options.onError(err);
        }
    }, [
        options
    ]);
    var handleFetch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
            var resp, parsedError;
            return _builds_pinvest_web_pinfinance_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        dispatch({
                            type: "loading",
                            payload: true
                        });
                        _ctx.next = 4;
                        return fetcher(body);
                    case 4:
                        resp = _ctx.sent;
                        dispatch({
                            type: "data",
                            payload: resp
                        });
                        handleSuccess(resp);
                        return _ctx.abrupt("return", resp);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        parsedError = typeof _ctx.t0 === "string" ? JSON.parse(_ctx.t0) : _ctx.t0;
                        dispatch({
                            type: "error",
                            payload: parsedError
                        });
                        handleError(parsedError);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(body) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fetcher,
        handleSuccess,
        handleError
    ]);
    return {
        data: state.data,
        isLoading: state.isLoading,
        error: state.error,
        fetch: handleFetch
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMutation);


/***/ }),

/***/ 1268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addThousandSeparator; }
/* harmony export */ });
/* harmony import */ var _utils_regex_commonRegex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6934);

var langToSeparator = {
    id: ".",
    en: ","
};
var ONE_THOUSAND = 1000;
function addThousandSeparator(value) {
    var lang = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "id";
    if (!value && typeof value !== "number") return "";
    if (value < ONE_THOUSAND && value > -ONE_THOUSAND) return value.toString();
    var _lang;
    return value.toString().replace(_utils_regex_commonRegex__WEBPACK_IMPORTED_MODULE_0__/* .thousandSeparatorPositionRegex */ .k, (_lang = langToSeparator[lang]) !== null && _lang !== void 0 ? _lang : langToSeparator.id);
};


/***/ }),

/***/ 481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HN": function() { return /* binding */ emailRegex; },
/* harmony export */   "pA": function() { return /* binding */ numberRegex; },
/* harmony export */   "tj": function() { return /* binding */ decimalNumberWithCommaRegex; }
/* harmony export */ });
/* unused harmony export phoneNumberRegex */
var numberRegex = /^[0-9]+$/;
var decimalNumberWithCommaRegex = /^\d+([,\d]?)([\d]+)?$/;
var phoneNumberRegex = /^8[0-9]{8,14}$/;
var emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;


/***/ }),

/***/ 7866:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"acd-b2b__simulation-form":"styles_acd-b2b__simulation-form__QJWrb","acd-b2b__simulation-form-input":"styles_acd-b2b__simulation-form-input__ieMfE","acd-b2b__simulation-form-input_full":"styles_acd-b2b__simulation-form-input_full__4z6Qd","acd-b2b__simulation-estimation":"styles_acd-b2b__simulation-estimation__OmMX0","acd-b2b__simulation-estimation_green":"styles_acd-b2b__simulation-estimation_green__9k4nR","acd-b2b__simulation-estimation_subtle":"styles_acd-b2b__simulation-estimation_subtle__FpVgR","acd-b2b__simulation-estimation-cta":"styles_acd-b2b__simulation-estimation-cta___x88r","acd-b2b__simulation-estimation-text":"styles_acd-b2b__simulation-estimation-text___JJof","acd-b2b__simulation-form-select":"styles_acd-b2b__simulation-form-select__nbj63","acd-b2b__simulation-esbt":"styles_acd-b2b__simulation-esbt__uG2xL","form__item-label":"styles_form__item-label__sSDTC","acd-b2b__simulation-estimation__imark":"styles_acd-b2b__simulation-estimation__imark___OTut","acd-b2b__simulation-estimation__imark-title":"styles_acd-b2b__simulation-estimation__imark-title__JvgZC","acd-b2b__simulation-estimation__imark-content":"styles_acd-b2b__simulation-estimation__imark-content__Usjq_","acd-b2b__simulation-estimation__imark-cta":"styles_acd-b2b__simulation-estimation__imark-cta__p_MEG","acd-b2b__simulation-esbt_left":"styles_acd-b2b__simulation-esbt_left__gHv_0","acd-b2b__simulation-esbt_right":"styles_acd-b2b__simulation-esbt_right__6n6as","acd-b2b__simulation-estimation-cta_sticky":"styles_acd-b2b__simulation-estimation-cta_sticky__Wvee5"};

/***/ }),

/***/ 2615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"submission__popup":"styles_submission__popup__YItr2","submission__popup-header":"styles_submission__popup-header__B_U5G","submission__popup-header-button":"styles_submission__popup-header-button__VKa2_","submission__popup-body":"styles_submission__popup-body__pnIjg","submission__popup-ctas":"styles_submission__popup-ctas__SeDvI","submission__popup-cta":"styles_submission__popup-cta__YJqsx","submission__popup-checkbox__wrapper":"styles_submission__popup-checkbox__wrapper__O2zDT","submission__popup-checkbox":"styles_submission__popup-checkbox__SP70R"};

/***/ })

}]);